import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PropTypes from "prop-types";
// material ui core
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

// Style
import { withStyles } from "@material-ui/core/styles";
import subscriptionCommon from "../Subscription/common";
import basketUtil from "../Subscription/basket";

// Library
import _ from "lodash";

class OrderSummary extends React.Component {
  getDateTime = timestamp => {
    var date = new Date(timestamp * 1000);
    return date.toLocaleDateString();
  };
  LineItemTaxesRenderTotals = taxes => {
    const line = _.map(taxes, taxItem => {
      return (
        <Grid container spacing={3}>
          <Grid item xs={10} md={10}>
            {taxItem.name} ({taxItem.description})
          </Grid>
          <Grid item xs={2} md={2}>
            ${taxItem.amount / 100}
          </Grid>
        </Grid>
      );
    });
    return <Grid>{line} </Grid>;
  };
  // Call like this:
  // { this.LineItemTaxesRender(lineItems, taxItems, mainItem.id, "plan") }
  // { this.LineItemTaxesRender(lineItems, taxItems, item.id, "addon") }
  LineItemTaxesRender = (lineItems, taxItems, itemId, itemType) => {
    const lineItem = _.find(lineItems, item => item.entity_type === itemType && item.entity_id === itemId);
    const lineItemTaxes = _.filter(taxItems, tax => tax.line_item_id === lineItem.id);
    if (lineItemTaxes && lineItemTaxes.length > 0) {
      const line = _.map(lineItemTaxes, taxItem => {
        return (
          <Grid>
            <Grid container spacing={3}>
              <Grid item xs={10} md={10}>
                {taxItem.tax_name} (rate: {taxItem.tax_rate}%, taxable: ${taxItem.taxable_amount / 100})
              </Grid>
              <Grid item xs={2} md={2}>
                ${taxItem.tax_amount / 100}
              </Grid>
            </Grid>
          </Grid>
        );
      });
      return line;
    }
    return "";
  };

  OrderSummaryRender = () => {
    const {
      classes,
      orderState,
      subs,
      estimate,
      handleBillPeriodChange,
      onSubscribeClick,
      basket,
      enableSubmit
    } = this.props;
    let taxItems = undefined;
    let lineItems = undefined;
    let taxItemTotals = undefined;
    try {
      taxItems = estimate.estimate ? estimate.estimate.invoice_estimate.line_item_taxes : undefined;
      lineItems = estimate.estimate ? estimate.estimate.invoice_estimate.line_items : undefined;
      taxItemTotals = estimate.estimate ? estimate.estimate.invoice_estimate.taxes : undefined;
    } catch (err) {}

    let planInfo = "";
    planInfo = "( " + subs.plan.description + ")";

    console.log("OrderSummary orderState.addNumberOfLicences", orderState.addNumberOfLicences);
    const fiksedUserLicences = basketUtil.getFiksedLicenses(basket, orderState.deployTheBot, orderState.licenses);
    var addLicences = 0;
    if (!orderState.deployTheBot) {
      if (fiksedUserLicences < orderState.numberOfLicences)
        addLicences = orderState.numberOfLicences - fiksedUserLicences;
    } else {
      if (orderState.addNumberOfLicences > 0) addLicences = orderState.addNumberOfLicences;
    }

    const mainItem = basketUtil.getMainItem(basket);
    if (estimate && estimate.estimate) {
      console.log("MainItem", mainItem);
      console.log("TaxItems", taxItems);
    }

    const addonItems = basketUtil.getAddonItems(basket, addLicences, orderState.deployTheBot, orderState.licenses);
    const basketTotal = mainItem.total + _.sumBy(addonItems, item => item.total);

    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Bill To
        </Typography>
        <Typography variant="body2">
          {orderState.billing_first_name} {orderState.billing_last_name}
          <br />
          {orderState.billing_company_name}
          <br />
          {orderState.billing_email}
          <br />
          {orderState.billing_phone_number}
          <br />
          {orderState.billing_address_line_1}
          <br />
          {orderState.billing_zip} {orderState.billing_city}
          <br />
          {orderState.billing_country_name}
          <br />
          {orderState.billing_state}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            &nbsp;
          </Grid>
        </Grid>
        <Typography variant="h4" gutterBottom style={{ display: "flex", justifyContent: "center" }}>
          Order Summary
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            &nbsp;
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={6} md={6}>
            <Button
              variant={orderState.billOption === "monthly" ? "outlined" : "text"}
              color="primary"
              onClick={handleBillPeriodChange}
            >
              Bill monthly
            </Button>
          </Grid>
          <Grid item xs={6} md={6}>
            <Button
              color="primary"
              variant={orderState.billOption === "annualy" ? "outlined" : "text"}
              onClick={handleBillPeriodChange}
            >
              Bill annualy
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            &nbsp;
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={1} md={1}>
            <b>{mainItem.count}</b>
          </Grid>
          <Grid item xs={9} md={9}>
            <b>{mainItem.name}</b>
          </Grid>
          <Grid item xs={2} md={2}>
            <b>${mainItem.total / 100}</b>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={10} md={10}>
            <i>{mainItem.description}</i>
            <br />
            <i>{mainItem.planInfo}</i>
          </Grid>
          <Grid item xs={2} md={2} />
        </Grid>
        {addonItems
          ? _.map(addonItems, item => {
              return (
                <Grid key={item.id}>
                  <Grid container spacing={3}>
                    <Grid item xs={1} md={1}>
                      <b>{item.count}</b>
                    </Grid>
                    <Grid item xs={9} md={9}>
                      <b>{item.name}</b>
                    </Grid>
                    <Grid item xs={2} md={2}>
                      <b>${item.total / 100}</b>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={10} md={10}>
                      <i>{item.description}</i>
                      <br />
                      <i>{item.planInfo}</i>
                    </Grid>
                    <Grid item xs={2} md={2} />
                  </Grid>
                </Grid>
              );
            })
          : ""}
        {taxItems ? this.LineItemTaxesRenderTotals(taxItemTotals) : ""}
        <Grid container spacing={3}>
          <Grid item xs={10} md={10}>
            <Typography>
              <b>Total</b>
            </Typography>
          </Grid>
          <Grid item xs={2} md={2}>
            <b>${estimate.estimate ? estimate.estimate.invoice_estimate.total / 100 : basketTotal / 100}</b>
          </Grid>
        </Grid>
        {taxItems && false ? (
          <Grid container spacing={3}>
            <Grid item xs={10} md={10}>
              <Typography>Total includes taxes:</Typography>
            </Grid>
            <Grid item xs={2} md={2}>
              <b />
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        {/* {taxItems
          ? _.map(taxItems, taxItem => {
              return (
                <Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={10} md={10}>
                      Incl. {taxItem.tax_name} (rate: {taxItem.tax_rate}%, taxable: ${taxItem.taxable_amount / 100})
                    </Grid>
                    <Grid item xs={2} md={2}>
                      ${taxItem.tax_amount / 100}
                    </Grid>
                  </Grid>
                </Grid>
              );
            })
          : ""} */}
        {estimate.estimate ? (
          <Grid container>
            <Grid item xs={12} md={12}>
              <br />
            </Grid>
            <Grid item xs={12} md={12}>
              <i>
                (First bill total estimate is $
                {estimate.estimate ? estimate.estimate.prorate_invoice_estimate.total / 100 : basketTotal / 100} for
                period from {this.getDateTime(estimate.estimate.prorate_invoice_estimate.line_items[0].date_from)}
                &nbsp;to {this.getDateTime(estimate.estimate.prorate_invoice_estimate.line_items[0].date_to)} )
              </i>
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            &nbsp;
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} style={{ display: "flex", justifyContent: "center" }}>
            <Button color="primary" variant="contained" onClick={onSubscribeClick} disabled={!enableSubmit}>
              {!enableSubmit ? "Please wait ..." : "Purchase"}
            </Button>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    return this.OrderSummaryRender();
  }
}

OrderSummary.propTypes = {};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

OrderSummary = connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderSummary);

export default withStyles(subscriptionCommon.styles)(OrderSummary);
